export const getCounter = {
  methods: {
    getCounter(maxLength, value) {
      return maxLength - String(value).replace(/\s/g, '').length;
    },
  },
};

export const isCounter = {
  methods: {
    isCounter(counter, maxLength, value) {
      return counter && String(value).replace(/\s/g, '').length >= maxLength / 2;
    },
  },
};

export const getValidationInfo = {
  methods: {
    // eslint-disable-next-line complexity
    getValidationInfo(v) {
      let [title, count, val] = ['', 0, v.value];

      if (val.required === false) {
        title += `${++count}) Поле обязательное \n`;
      }

      if (val.minLength === false) {
        title += `${++count}) Минимум символов - "${val.$params.minLength.min}" \n`;
      }

      if (val.maxLength === false) {
        title += `${++count}) Максимум символов - "${val.$params.maxLength.max}" \n`;
      }

      if (Object.prototype.hasOwnProperty.call(val, 'email') && !val.email) {
        title += `${++count}) Адрес почты не корректен \n`;
      }

      if (Object.prototype.hasOwnProperty.call(val, 'isUrl') && !val.isUrl) {
        title += `${++count}) Ссылка не корректна \n`;
      }

      if (Object.prototype.hasOwnProperty.call(val, 'isPhone') && !val.isPhone) {
        title += `${++count}) Номер телефона не корректен \n`;
      }

      if (Object.prototype.hasOwnProperty.call(val, 'isNotPPRouteUrls') && !val.isNotPPRouteUrls) {
        title += `${++count}) Такой Id запрещён системой \n`;
      }

      if (Object.prototype.hasOwnProperty.call(val, 'isUrlOrIframe') && !val.isUrlOrIframe) {
        title += `${++count}) Допустимы ссылки и <iframe>\n`;
      }

      return title;
    },
  },
};
